export default function normalizeAboutHtml(html) {
    if (!html) return "";
    return String(html)
        .replace(/<\/?font\b[^>]*>/gi, "")
        .replace(/font-family\s*:\s*[^;"']+;?/gi, "")
        .replace(/\sstyle="\s*"/gi, "");
}
